import { OPORD_TEMPLATE_ID } from 'components/DisasterGPT/constants/opordSectionDefaults';
import generateUUID from 'utils/sharedUtils/generateUUID';

type BuildDraftSitrepPayloadParams = {
  scopeName: string;
  aorId?: string | null;
  incidentId?: string;
  // Sitrep template to seed sections from.
  templateId: string;
  // When true (and no useful template), create with no sections. Kept for
  // callers that pass through CreateDraftReportSelection.
  skipDefaultSections?: boolean;
};

export function draftReportNameForTemplate(
  templateId: string,
  scopeName: string
): string {
  if (templateId === OPORD_TEMPLATE_ID) {
    return `OPORD: ${scopeName}`;
  }
  return `Report: ${scopeName}`;
}

export const buildDraftSitrepPayload = ({
  scopeName,
  aorId,
  incidentId,
  templateId,
  skipDefaultSections = false,
}: BuildDraftSitrepPayloadParams) => ({
  skip_default_sections: templateId ? false : skipDefaultSections,
  sitrep_template_id: templateId,
  sitrep_source: 'reports',
  sitrep_source_id: generateUUID(),
  name: draftReportNameForTemplate(templateId, scopeName),
  description: '',
  selectedDatetime: new Date().toISOString(),
  aor_id: aorId || undefined,
  incident_id: incidentId || undefined,
  is_sitrep: true,
});
